/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Nachhaltige Gastronomie`
};

const en_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Sustainable gastronomy`
};

const es_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Gastronomía sostenible`
};

const fr_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Gastronomie durable`
};

const it_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Gastronomia sostenibile`
};

const nl_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Duurzame gastronomie`
};

const pt_restaurantmichelin_greenstarlabel3 = /** @type {(inputs: {}) => string} */ () => {
	return `Gastronomia sustentável`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const restaurantmichelin_greenstarlabel3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.restaurantmichelin_greenstarlabel3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("restaurantmichelin_greenstarlabel3", locale)
	if (locale === "de") return de_restaurantmichelin_greenstarlabel3(inputs)
	if (locale === "en") return en_restaurantmichelin_greenstarlabel3(inputs)
	if (locale === "es") return es_restaurantmichelin_greenstarlabel3(inputs)
	if (locale === "fr") return fr_restaurantmichelin_greenstarlabel3(inputs)
	if (locale === "it") return it_restaurantmichelin_greenstarlabel3(inputs)
	if (locale === "nl") return nl_restaurantmichelin_greenstarlabel3(inputs)
	return pt_restaurantmichelin_greenstarlabel3(inputs)
};
export { restaurantmichelin_greenstarlabel3 as "restaurantMichelin_greenStarLabel" }